import { GridColumn } from "@ucl/library";

export const TaskRuleGridConfig: GridColumn[] = [
  new GridColumn({
    field: "taskRuleName",
    headerText: "Task Rule Name",
    type: "string",
    maxWidth: 400,
  }),
  new GridColumn({
    field: "taskTemplate_Name",
    headerText: "Task Template",
    type: "string",
    maxWidth: 400,
  }),
  new GridColumn({
    field: "taskRuleType_AsString",
    headerText: "Task Rule Type",
    type: "string",
    maxWidth: 400,
  }),
  new GridColumn({
    field: "isActive",
    headerText: "Active",
    type: "boolean",
    valueAccessor: (field, data) => {
      const val = (data as unknown as { [key: string]: string })[
        field
      ].toString();
      if (!val) return "";
      return val;
    },
    maxWidth: 400,
  }),
  new GridColumn({
    field: "createdBy_AsName",
    headerText: "Created By",
    type: "string",
    maxWidth: 400,
  }),
  new GridColumn({
    field: "createdAt",
    headerText: "Created Date",
    format: { format: "MM/dd/yyyy hh:mm:ss a", type: "date" },
    type: "datetime",
    maxWidth: 400,
    allowSearching: false,
    allowFiltering: false,
  }),
  new GridColumn({
    field: "updatedBy_AsName",
    headerText: "Updated By",
    type: "string",
    maxWidth: 400,
  }),
  new GridColumn({
    field: "updatedAt",
    headerText: "Updated Date",
    format: { format: "MM/dd/yyyy hh:mm:ss a", type: "date" },
    type: "datetime",
    maxWidth: 400,
    allowSearching: false,
    allowFiltering: false,
  }),
];
